/* eslint-disable @typescript-eslint/naming-convention */
import { CroutonComms, ReinforcementComms } from "./BlackMembership";
import {
    PlanDetails,
    BullsEyeCardComms,
    FrequencyCap,
    HalfcardVariants,
    TGLogoCTX,
    TGCTAs,
    Content,
    Title,
    RemovePlanAttributeValues,
} from "./ExtraItem";
export interface SwiggyOneInfo {
    presentationInfo: PresentationInfo;
}

export enum AssetType {
    ASSET_TYPE_IMAGE = "ASSET_TYPE_IMAGE",
    ASSET_TYPE_LOTTIE = "ASSET_TYPE_LOTTIE",
}

export interface AssetCtx {
    link: string;
    type: AssetType;
}

export enum M2cTypes {
    DEFAULT = "DEFAULT",
    M2C_BLACK_RENEWAL = "M2C_BLACK_RENEWAL",
}

export interface M2cIdentifiers {
    m2c_type?: M2cTypes;
}

export interface M2CCardComms {
    content_image?: string;
    logo_ctx: TGLogoCTX;
    title: string;
    subtitles?: string[];
    content?: Content[];
    ctas: TGCTAs[];
    note?: string;
    attribute_values: Record<string, string>;
    variant?: HalfcardVariants;
    frequency_cap: FrequencyCap;
    identifiers: M2cIdentifiers;
    asset_ctx: AssetCtx[];
}

export interface M2CGratificationCardComms {
    header: string;
    logo_ctx: TGLogoCTX;
    title: string;
    content?: Content[];
    duration?: number;
}

export interface SwiggyOneGratificationCard extends M2CGratificationCardComms {
    sub_titles?: string[];
    attribute_values: Record<string, string>;
    cta: TGCTAs;
    variant?: string;
}

export interface BillDetailsCardCommes extends BullsEyeCardComms {
    title: string;
}

export interface ItemNudgeComms {
    title: string;
    logo_ctx: TGLogoCTX;
    ctas: TGCTAs[];
    note: string;
    attribute_values: Record<string, string>;
}

export enum ComparisonNudgeVariant {
    VARIANT_TOP = "VARIANT_TOP",
    VARIANT_BOTTOM = "VARIANT_BOTTOM",
}

export interface ComparisonNudgeItem {
    logo_ctx: TGLogoCTX;
    plan_details: PlanDetails;
    sub_titles: string[];
    attribute_values: {
        tenure_text: string;
    };
    ctas: TGCTAs[];
    note?: string;
}

export interface ComparisonNudgeComms {
    header: string;
    variant: ComparisonNudgeVariant;
    nudges: ComparisonNudgeItem[];
}

export interface IRemovePlanMessage {
    logo_ctx: TGLogoCTX;
    title: Title;
    content: Content[];
    attribute_values: RemovePlanAttributeValues;
    variant: string;
}

export interface IBenefitReinforcementComms {
    frequency_cap: FrequencyCapHeader;
    enabled: boolean;
    delay: Delay;
}

interface FrequencyCapHeader {
    id: string;
    count: number;
    session_count: number;
}

interface Delay {
    value: number;
    unit: string;
}

export interface PresentationInfo {
    nudge_type: string;
    m2c_card_comms?: M2CCardComms;
    m2c_gratification_card_comms?: M2CGratificationCardComms;
    bill_details_card_comms?: BillDetailsCardCommes | null;
    plan_details: PlanDetails;
    item_nudge_comms?: ItemNudgeComms | null;
    comparison_nudge_comms?: ComparisonNudgeComms;
    swiggy_one_nudge_gratification_card_comms?: SwiggyOneGratificationCard;
    remove_plan_message: IRemovePlanMessage;
    reinforcement_comms: ReinforcementComms;
    crouton_comms: CroutonComms;
    benefit_reinforcement_comms?: IBenefitReinforcementComms;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    [key: string]: any;
}
